import * as storage from '../utilities/storage';

import { ACCESS_TOKEN } from '../constants/storage';

/**
 * Persist token to storage.
 *
 * @param {{accessToken, refresToken}} params
 */
export function persist({ accessToken }) {
  setAccessToken(accessToken);
}

/**
 * Get access token from storage.
 *
 * @returns {string}
 */
export function getAccessToken() {
  return storage.get(ACCESS_TOKEN);
}

/**
 * Set access token to storage.
 *
 * @param {string} accessToken
 */
export function setAccessToken(accessToken) {
  storage.set(ACCESS_TOKEN, accessToken);
}

/**
 * Clear tokens.
 */
export function clear() {
  const theme = storage.get('theme');
  storage.clear();

  //persist theme value
  storage.set('theme', theme);
}
